module.exports = __webpack_public_path__ + "assets/img/2d1a490419b29c5dc5f3958c5ddb4312.png";